import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import './utils/inactivityMonitor'; // Auto-initializes event listeners on window
import Header from './components/Header';
import AppInitializer from './components/AppInitializer';
// import { loadActiveUploads } from './redux/slices/uploadProgressSlice'; // DISABLED
// import { loadActiveUploadsFromStorage } from './redux/middleware/localStorageMiddleware'; // DISABLED
import WakeLockManager from './components/WakeLock/WakeLockManager';
import { initializeAuthGuard } from './utils/authGuard';

const App = () => {
  useEffect(() => {
    initializeAuthGuard();

    // Inactivity monitor now auto-initializes via async IIFE in inactivityMonitor.js

    // Load active uploads from localStorage on app start - DISABLED
    // const savedUploads = loadActiveUploadsFromStorage();
    // if (savedUploads.length > 0) {
    //   store.dispatch(loadActiveUploads(savedUploads));
    // }
  }, []);

  return (
    <Provider store={store}>
      <AppInitializer>
        <React.Fragment>
          <BrowserRouter>
           <WakeLockManager />
            <div className='container-outer'>
              <Header />
            </div>
          </BrowserRouter>
        </React.Fragment>
      </AppInitializer>
    </Provider>
  );
}

export default App;